import React from "react";
import { useSelector } from "react-redux";

import NonLoggedInUserHeader from "./NonLoggedInUserHeader";
import LoggedInUserHeader from "./LoggedInUserHeader";
import Alert from '@mui/material/Alert';
import {useLocation} from 'react-router-dom'

const Header = () => {
  const isAuthenticated = useSelector(
    (state) => state.basicInfo.isAuthenticated
  );

  const is_admin_varified = useSelector(
    (state) => state?.basicInfo?.userDetails?.is_admin_verified
  );

  let {pathname} = useLocation();

  const userType = useSelector(
    (state) => state?.basicInfo?.userDetails?.user_type
  );

  const gps_error = useSelector(
    (state) => state?.carrierPosition?.positionResponse
  );



  return (
    <>
      {isAuthenticated ? <LoggedInUserHeader /> : <NonLoggedInUserHeader />}

      {
        !is_admin_varified && is_admin_varified !== undefined && pathname !== '/complete-user-profile' &&
        <Alert className="justify-content-center" severity="warning">Account is not verified by admin yet !</Alert>
      }

      {
        gps_error === "error" && userType === "carrier" && pathname !== '/complete-user-profile' &&
        <Alert className="justify-content-center" severity="warning"> Connect to your GPS ! </Alert>
      }
    </>
  );
};

export default Header;
